module.exports = __webpack_public_path__ + "static/media/info.ddef444d.svg";